<main class="c-main" role="main">
    <div class="c-page-access">
      <div class="container u-pb30"> 
        <div class="row mobile--orange u-pt40">
          <div class="col-md-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a [routerLink]="['']" > {{'MyAuthAccessDetailPortal.home' | translate}}</a></li>
                <li class="breadcrumb-item active" aria-current="page">- <a [routerLink]="['/my-authorised-accesses']"> {{'MyAuthAccessDetailPortal.level2'| translate}}</a></li>
                <li class="breadcrumb-item active" aria-current="page"> - <span >{{'MyAuthAccessDetailPortal.location' | translate}} </span></li>
              </ol>
            </nav>
            <h2 class="o-title js-txt3">{{'MyAuthAccessDetailPortal.title' | translate}}</h2>
            <p class="o-text o-text--description js-txt4"> {{'MyAuthAccessDetailPortal.subtitle' | translate}}</p>
          </div>
        </div>
        <div class="row u-pt20">
          <div class="col-md-12">
            <div class="c-card c-card--success c-card--success-main" *ngIf="access!=undefined">
              <div class="c-card__title">{{access.siteName}}<span class="js-txt16">{{'MyAuthAccessDetailPortal.titleTable' | translate}}</span></div>
              <div class="row"> 
                <div class="col-md-4">
                  <p class="table__request"><strong class="js-txt6">{{'MyAuthAccessDetailPortal.labelRequestNumber' | translate}}: </strong> {{access.accessDetail.requestNumber}}</p>
                  <p><strong class="js-txt7">{{'MyAuthAccessDetailPortal.labelRequestor' | translate}}: </strong> {{access.requestor}}</p>
                </div>
                <div class="col-md-4"> 
                  <p> <strong class="js-txt9">{{'MyAuthAccessDetailPortal.labelZone' | translate}}: </strong> {{access.zoneName}} </p>
                  <p *ngIf="access.subZoneName != ''"> <strong class="js-txt9">{{'MyAuthAccessDetailPortal.labelSubzone' | translate}}: </strong> {{access.subZoneName}} </p>
                </div>
                <div class="col-md-4">
                  <div class="c-card__from"><i class="icon icon-calendar"></i>
                    <p> <strong class="js-txt10">{{'MyAuthAccessDetailPortal.labelFrom' | translate}} </strong>{{access.accessDetail.periodFrom | date: 'dd/MM/yyyy'}}</p>
                  </div>
                  <div class="c-card__to"><i class="icon icon-calendar"></i>
                    <p> <strong class="js-txt11">{{'MyAuthAccessDetailPortal.labelTo' | translate}} </strong>{{access.accessDetail.periodTo | date: 'dd/MM/yyyy'}}</p>
                  </div>
                </div>
                <div class="col-md-12 c-card__alert">
                  <p> <i class="icon icon-alert"> </i><span class="js-txt21">{{'MyAuthAccessDetailPortal.warning' | translate}}</span></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 u-pt40"> 
            <h2 class="o-title o-title--medium o-title--orange js-txt23">{{'MyAuthAccessDetailPortal.titleInformation' | translate}}</h2>
            <p class="o-text js-txt24">{{'MyAuthAccessDetailPortal.subtitleInformation' | translate}}  </p>
          </div>
        </div>
      </div>
      <div class="o-tabs c-accordeon-cep">
        <div class="o-tabs__list">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <ul >
                  <li class="transition" (click)="optionMenu=1"  [className]="optionMenu===1 ? 'active' : ''"> {{'MyAuthAccessDetailPortal.tabBeforeArriving' | translate}} </li>
                  <li class="transition" (click)="optionMenu=2" [className]="optionMenu===2 ? 'active' : ''"rel="tab2">{{'MyAuthAccessDetailPortal.tabDuringVisit' | translate}}</li>
                  <li class="transition" (click)="optionMenu=3" [className]="optionMenu===3 ? 'active' : ''">{{'MyAuthAccessDetailPortal.tabEmergency' | translate}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="container" style="padding-bottom: 50px;">
          <div class="row">
            <div class="col-md-12">
              <div class="o-tabs__container" style="padding-top: 25px;">
                  <div *ngIf="optionMenu===1">
                
                <div class="" id="tab1">  
                  <mat-accordion class="example-headers-align" multi *ngIf="access">
                    <div class="c-accordeon__item" *ngFor="let itemArr of access.selfInformation.arrivingInformation">

                  
                    <mat-expansion-panel  >
                      <mat-expansion-panel-header style="height: 200px; ">
                        <mat-panel-title>
                          <strong *ngIf="getlang()==='en'"  class="js-txta1">{{itemArr.titleEng}}</strong>
                          <strong *ngIf="getlang()==='es'" class="js-txta1">{{itemArr.titleEsp}}</strong>
                        </mat-panel-title>
                      
                      </mat-expansion-panel-header>
                      <span *ngIf="getlang()==='es'" style="white-space: pre-line;" class="js-txta2">{{itemArr.descriptionEsp}}</span>
                      <span *ngIf="getlang()==='en'" style="white-space: pre-line" class="js-txta2">{{itemArr.descriptionEng}}</span>
                     
                      
                    </mat-expansion-panel>
                  </div>
                  </mat-accordion>


                </div>
            </div>
            <div *ngIf="optionMenu===2">
               
                <div class="" id="tab2">
                  
                  <mat-accordion class="example-headers-align" multi *ngIf="access">
                    <div class="c-accordeon__item" *ngFor="let itemVis of access.selfInformation.visitInformation">

                    
                    <mat-expansion-panel  >
                      <mat-expansion-panel-header style="height: 200px; ">
                        <mat-panel-title>
                          <strong *ngIf="getlang()==='en'" class="js-txta1">{{itemVis.titleEng}}</strong>
                          <strong *ngIf="getlang()==='es'" class="js-txta1">{{itemVis.titleEsp}}</strong>
                        </mat-panel-title>
                      
                      </mat-expansion-panel-header>
                      <span *ngIf="getlang()==='es'" style="white-space: pre-line;" class="js-txta2">{{itemVis.descriptionEsp}}</span>
                      <span *ngIf="getlang()==='en'" style="white-space: pre-line;" class="js-txta2">{{itemVis.descriptionEng}}</span>
                     
                      
                    </mat-expansion-panel>
                  </div>
                  </mat-accordion>

                </div>
            </div>
            <div *ngIf="optionMenu===3">
                
                <div class="" id="tab3" *ngFor="let itemEm of access.selfInformation.emergencyInformation">
                  <div class="col-md-6 u-pt30">
                    <p class="o-text js-txta15">{{'MyAuthAccessDetailPortal.emergencyDes1' | translate}}</p>
                    <p class="o-text js-txta16">{{'MyAuthAccessDetailPortal.emergencyDes2' | translate}}</p>
                  </div>
                  <div class="col-md-6 u-pt30 u-pb40">
                    <div class="c-number"> 
                      <p >{{'MyAuthAccessDetailPortal.emergencyDes3' | translate}} </p> <strong> <i class="icon icon-phone"> </i><a >{{itemEm.emergencyPhone}}</a></strong>
                    </div>
                  </div>
                </div>
            </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>